import script from "./BudgetTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetTable.vue?vue&type=script&setup=true&lang=js"

import "./BudgetTable.vue?vue&type=style&index=0&id=0b641159&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b641159"]])

export default __exports__